export default "__VITE_ASSET__CGtAglM0__"